import React from 'react';
import { COPY } from '../../contracts/copyMap';

// Shared renderer for the Terms of Service / Privacy Policy section lists.
// Single presentation for both the LegalModal (onboarding + auth surface) and
// the routed public legal pages (/legal/terms, /legal/privacy). The content
// itself lives once in copyMap (LEGAL_TOS_SECTIONS / LEGAL_PRIVACY_SECTIONS).
//
// `doc` is 'tos' | 'privacy'.
export const TITLES = {
  tos: COPY.ONBOARDING_TERMS_LINK_TOS,
  privacy: COPY.ONBOARDING_TERMS_LINK_PRIVACY,
};

const SECTIONS = {
  tos: COPY.LEGAL_TOS_SECTIONS,
  privacy: COPY.LEGAL_PRIVACY_SECTIONS,
};

const LegalSections = ({ doc }) => {
  const sections = SECTIONS[doc] || [];
  return (
    <div className="space-y-5">
      {sections.map((section) => (
        <section key={section.heading}>
          <h3 className="m-0 font-display uppercase tracking-[0.14em] text-[12px] text-aurum">
            {section.heading}
          </h3>
          <p className="mt-2 m-0 font-display text-[15px] leading-relaxed text-bone">
            {section.body}
          </p>
        </section>
      ))}
    </div>
  );
};

export default LegalSections;
